<script lang="ts">
  import { onMount } from 'svelte';
  
  export let src: string;
  export let alt: string;
  export let caption: string;
  
  let container: HTMLElement;
  
  onMount(() => {
    const handleScroll = () => {
      if (!container) return;
      const rect = container.getBoundingClientRect();
      const scrollPercent = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      container.style.setProperty('--scroll', scrollPercent.toString());
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial position

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });
</script>

<div class="w-full mb-16">
  <div class="w-full overflow-hidden lg:px-8" bind:this={container}>
    <img 
      src={src} 
      alt={alt} 
      class="w-full h-auto object-cover parallax-image"
    />
  </div>
  {#if caption}
    <div class="px-8 mt-4">
      <p class="text-sm text-gray-600">
        {caption}
      </p>
    </div>
  {/if}
</div>

<style>
  .parallax-image {
    transform: translateY(calc(var(--scroll, 0) * 200px));
    will-change: transform;
    transition: transform 0.1s linear;
  }

  img {
    will-change: transform;
    backface-visibility: hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style> 